/**
 * 优惠字段 对应的表格单元格
 */
import Offer from './offer.vue';
export default Offer;
